module.exports = __webpack_public_path__ + "d8f1b747ba94f3caa61a85a9d8f60c6c.svg";